import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { api, type CatalogItem } from "../data/api.js";

// Testy hlavní sekce katalogu s vrstvou portrétu (počítané vrstvy, CR-021 §5). Lehký modul bez
// kódu kreslení: používá ho i karta cizího návštěvníka (CR-024 §2).

/** Testy hlavní sekce s vrstvou, `null` do odpovědi. */
export function useMainCatalog(): CatalogItem[] | null {
  const intl = useIntl();
  const [items, setItems] = useState<CatalogItem[] | null>(null);
  useEffect(() => {
    let live = true;
    api.catalog(intl.locale).then(
      (c) => {
        if (live) setItems(c.methodologies.filter((m) => m.section === "main" && m.layer !== null));
      },
      () => {
        if (live) setItems([]);
      },
    );
    return () => {
      live = false;
    };
  }, [intl.locale]);
  return items;
}
